<template>
  <div ref="container" class="spinner-wrapper"></div>
</template>

<script setup>
import { onMounted, ref, onBeforeUnmount } from 'vue'
import lottie from 'lottie-web'
import spinnerData from '@/assets/spinner.json'

const container = ref(null)
let animation

onMounted(() => {
  animation = lottie.loadAnimation({
    container: container.value,
    renderer: 'svg',
    loop: true,
    autoplay: true,
    animationData: spinnerData,
  })
})

onBeforeUnmount(() => {
  if (animation) animation.destroy()
})
</script>

<style scoped>
.spinner-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #fff;
}

.spinner-wrapper {
  width: 300px;
  height: 300px;
}
</style>

